import { booleanAttribute } from "#ce/utils/props";

/**
 * Behaviour flags for the event checkout's review step, shared by `sp-checkout` and the
 * `sp-event-registration` wrapper that forwards them.
 *
 * The step and section wording is not here — it comes from `frontend.event_checkout` in the locale
 * files, so a client rewords the flow through its own locale file rather than through markup.
 */
export const eventReviewProps = Object.freeze({
  /**
   * Hide the control that sends the registrant back to the participant step from the review.
   *
   * @type {Boolean|String}
   * @default false
   */
  hideReviewParticipantChange: booleanAttribute(),
  /**
   * Keep the participant form's group labels, which the event flow otherwise drops.
   *
   * @type {Boolean|String}
   * @default false
   */
  showParticipantFormGroupLabels: booleanAttribute(),
  /**
   * Hide the control that sends the registrant back to the payment step from the review.
   *
   * @type {Boolean|String}
   * @default false
   */
  hideReviewPaymentChange: booleanAttribute(),
});
